// extracted by mini-css-extract-plugin
export var currencyInput = "_k3-1";
export var currencySymbol = "_k3-0";